
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;


export default (props)=>{
    return (
        <RangePicker
            ranges={{
                '今日':[moment().hour(0).minute(0).second(0),moment().hour(23).minute(59).second(59)],
                '昨日':[moment().subtract(1,'d').hour(0).minute(0).second(0),moment().subtract(1,'d').hour(23).minute(59).second(59)],
                '本周':[moment().startOf('week').hour(0).minute(0).second(0),moment().hour(23).minute(59).second(59)],
                '上周':[moment().subtract(1,'week').startOf('week').hour(0).minute(0).second(0),moment().startOf('week').subtract(1,'d').hour(23).minute(59).second(59)],
                '本月':[moment().startOf('month').hour(0).minute(0).second(0),moment().hour(23).minute(59).second(59)],
                '上月':[moment().subtract(1,'M').startOf('month').hour(0).minute(0).second(0),moment().subtract(1,'M').endOf('month').hour(23).minute(59).second(59)],
                '最近三个月':[moment().subtract(3,'M').add(1,'d').hour(0).minute(0).second(0),moment().hour(23).minute(59).second(59)],
            }}
            allowClear
            // getPopupContainer={() => document.getElementById('area')}
            showTime={{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
            }}
            {...props}
        />
    )
}